import { TTranslator } from '@smartshell/ui-kit';
import { Column } from 'react-table';

import { TLocalesKeys } from 'localization';

import { TNormalizedTransfersSummaryReportData } from '../interfaces';

export const getTransfersSummaryColumns = (
  t: TTranslator<TLocalesKeys>,
  currency: string
): Array<Column<TNormalizedTransfersSummaryReportData>> => [
  {
    Header: t('club.title'),
    accessor: 'name',
    disableSortBy: true,
  },
  {
    Header: t('transfers.receipts'),
    accessor: 'input',
    Cell: ({ value }) => `${value} ${currency}`,
    disableSortBy: true,
  },
  {
    Header: t('transfers.withdrawals'),
    accessor: 'output',
    Cell: ({ value }) => `${value} ${currency}`,
    disableSortBy: true,
  },
  {
    Header: t('total'),
    accessor: 'remains',
    Cell: ({ value }) => `${Math.floor(value)} ${currency}`,
    disableSortBy: true,
  },
];
